module.exports = __webpack_public_path__ + "static/media/yes.9308918e.svg";